import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://ciam-apis.herokuapp.com/',
});

export default axiosInstance;
